import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormattedDatePipe} from '@common/core/ui/format-pipes/formatted-date.pipe';
import {FormattedFileSizePipe} from '@common/uploads/formatted-file-size.pipe';
import {FaviconPipe} from './favicon.pipe';
import {TitleCasePipe} from './title-case.pipe';
import {SnakeCasePipe} from '@common/core/ui/format-pipes/snake-case.pipe';
import {BackgroundUrlPipe} from '@common/core/ui/format-pipes/background-url.pipe';
import { DateTimeAgoPipe } from './date-time-ago.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { OrdinalPipe } from '@common/core/pipes/ordinal/ordinal.pipe';

@NgModule({
    declarations: [
        FormattedDatePipe,
        FormattedFileSizePipe,
        FaviconPipe,
        TitleCasePipe,
        SnakeCasePipe,
        BackgroundUrlPipe,
        DateTimeAgoPipe,
        SafeHtmlPipe,
        OrdinalPipe
    ],
    imports: [CommonModule],
    exports: [
        FormattedDatePipe,
        FormattedFileSizePipe,
        FaviconPipe,
        TitleCasePipe,
        SnakeCasePipe,
        BackgroundUrlPipe,
        DateTimeAgoPipe,
        SafeHtmlPipe,
        OrdinalPipe
    ],
    providers: [
        BackgroundUrlPipe,
    ]
})
export class FormatPipesModule {}
